<!-- 部门管理 -->
<template>
  <div class="definiteDetail" v-loading="loading">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="departmentName" placeholder="搜索部门名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
    </div>
    <!-- 表格 -->
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540" row-key="departmentId" :tree-props="{children: 'childDepartmentInfoVos'}">
        <!-- <el-table-column label="序号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column> -->
        <el-table-column  show-overflow-tooltip prop="departmentName" label="部门名称"></el-table-column>
        <el-table-column  show-overflow-tooltip prop="departmentHead" label="部门负责人"></el-table-column>
        
      </el-table>
    </div>
    <!-- 分页 -->
    <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount">
    </el-pagination> -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      departmentName: '', // 姓名

      // 表格数据
      tableData: [],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getNameList();
  },
  methods: {
    // 获取列表
    getNameList() {
      this.loading = true;
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        departmentName: this.departmentName,
      };
      this.$axios.get(this.$api.departmentInfoSelect, {
        params
      }).then((res) => {
          if (res.code == 100) {
            this.tableData = res.result;
          }
          this.loading = false;
        }).catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 清空
    clearData() {
      this.tableData = [];
      this.currentPage = 1;
    },
    // 搜索
    onSearch() {
      this.clearData();
      this.getNameList();
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData();
      this.pageSize = e;
      this.getNameList();
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = [];
      this.currentPage = e;
      this.getNameList();
    },
  }

}
</script>

<style lang="scss" scoped>
.definiteDetail {
}
</style>
